export default "__VITE_ASSET__134466e7__"